import { CountResponse } from './types';

export const mapSelectToScreenQuery = (data: CountResponse) => (typeof data === 'number' ? { count: data } : data);
